"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReportsPayload = void 0;
var getReportsPayload = exports.getReportsPayload = function getReportsPayload(values, props) {
  var accounts = props.accounts.map(function (a) {
    return a.AccountId;
  });
  var accountIdList = accounts.filter(function (id) {
    return values[id];
  });
  var payload = {
    accountIdList: accountIdList
  };
  Object.keys(values).filter(function (prop) {
    return !accounts.includes(prop);
  }).forEach(function (prop) {
    return payload[prop] = values[prop];
  });
  return payload;
};